// Libraries
import { Routes, Route } from "react-router-dom"


// Screens
import ListScreen from 'screens/Event/List';


// Layouts
import DefaultLayout from 'layouts/Default'


const MiscRoutes = () => 
{
	return (
		<DefaultLayout>
			<Routes>
				<Route exact path="/" element={<ListScreen/>}/>
			</Routes>
		</DefaultLayout>
	)
}


export default MiscRoutes
